import cardapio from 'data/cardapio.json';
import  styles from './Inicio.module.scss';
import  stylesTema from 'styles/Tema.module.scss';
import nossaCasa from 'assets/nossa_casa.png';
import { useNavigate } from 'react-router-dom';
import { Prato } from 'types/Prato';

export default function Inicio() {
  let pratosRecomendados = [...cardapio];
  pratosRecomendados = pratosRecomendados
    .sort(() => 0.5 - Math.random())
    .splice(0,3);

  const navigate = useNavigate();
  function redirecionarParaDetalhes(prato: Prato) {
    navigate(`/prato/${prato.id}`, {state: {prato}});
  }

  return (
    <section>
      <h3 className={stylesTema.titulo}>Recomendações da casa</h3>
      <div className={styles.recomendados}>
        {pratosRecomendados.map(item => (
          <div key={item.id} className={styles.recomendado}>
            <div className={styles.recomendado__imagem}>
              <img src={item.photo} alt={item.title}/>
            </div>
            <button className={styles.recomendado__botao} 
              onClick={()=> redirecionarParaDetalhes(item)}>
              Ver mais
            </button>
          </div>
        ))}
      </div>
      <h3 className={stylesTema.titulo}> Nossa casa </h3>
      <div className={styles.nossaCasa}>
        <img src={nossaCasa} alt="nossa casa" />
        <div className={styles.nossaCasa__endereco}>
          Rua Cidade Ecologica, 784 <br /> <br /> Vila Zezinha - CE
        </div>
      </div>
    </section>
  );
}